import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { buildHomeNavigationTarget, resolveActiveSiteCode } from '../utils/navigationContext';
import '../styles/np-theme.css';

/** Shown for any URL that matches no route (previously a blank page). */
const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    const { user, isGlobalAdmin } = useAuth();

    const home = user
        ? buildHomeNavigationTarget({
            user,
            isGlobalAdmin,
            siteCode: resolveActiveSiteCode({ userSiteCode: user.siteCode }),
        })
        : '/';

    return (
        <div className="np-page min-h-screen">
            <div className="np-theme max-w-xl mx-auto px-4 pt-32 pb-12">
                <div className="bg-white border border-slate-200 rounded px-6 py-8 text-center">
                    <span className="inline-flex items-center justify-center w-12 h-12 rounded bg-blue-50 text-blue-600">
                        <Compass size={22} aria-hidden="true" />
                    </span>
                    <h1 className="mt-4">Page not found</h1>
                    <p className="mt-2 text-sm text-slate-500">
                        The address may be mistyped, or the page has moved.
                    </p>
                    <div className="mt-5 flex flex-wrap justify-center gap-2">
                        <button
                            type="button"
                            onClick={() => navigate(home)}
                            className="inline-flex items-center h-9 px-4 rounded bg-blue-600 text-sm text-white hover:bg-blue-700"
                        >
                            {user ? 'Go to my plant' : 'Go to home page'}
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="inline-flex items-center h-9 px-4 rounded border border-slate-300 bg-white text-sm text-slate-700 hover:bg-slate-50"
                        >
                            Go back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
